import { render, staticRenderFns } from "./multiple-reviews-carousel.vue?vue&type=template&id=3e31c332&scoped=true&"
import script from "./multiple-reviews-carousel.vue?vue&type=script&lang=js&"
export * from "./multiple-reviews-carousel.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=3e31c332&scoped=true&lang=css&"
import style1 from "./multiple-reviews-carousel.vue?vue&type=style&index=1&id=3e31c332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e31c332",
  null
  
)

export default component.exports